import { ConfigProvider, Flex, Input, Select, Space } from 'antd'
import SearchIcon from '@/assets/search.svg?react'
import ChevronDownIcon from '@/assets/chevron-down.svg?react'
import { useTranslation } from 'react-i18next'

type Props = {
  categories: string[]
  categoryNames: Record<string, string>
  category: string | undefined
  onCategoryChange: (v: string | undefined) => void
  keyword: string
  onKeywordChange: (v: string) => void
}

const SEAMLESS = {
  activeShadow: 'none',
  activeBorderColor: 'transparent',
  hoverBorderColor: 'transparent',
}

export default function ScopeToolbar({
  categories,
  categoryNames,
  category,
  onCategoryChange,
  keyword,
  onKeywordChange,
}: Props) {
  const { t } = useTranslation()

  return (
    <Flex justify="space-between" align="center" wrap gap={12} style={{ marginBottom: 12 }}>
      <Space wrap size={10}>
        <ConfigProvider theme={{ components: { Input: SEAMLESS } }}>
          <div className="inline-flex h-8 items-stretch overflow-hidden rounded-lg border border-[#DCDCDC] bg-white/85">
            <span className="inline-flex items-center px-3 text-[13px] font-normal leading-none text-black">
              {t('scope.filterPermission')}
            </span>
            <span className="my-2 w-px shrink-0 bg-[#E7E7E7]" />
            <Input
              variant="borderless"
              allowClear
              suffix={<SearchIcon width={16} height={16} />}
              placeholder={t('scope.searchPlaceholder')}
              value={keyword}
              onChange={(e) => onKeywordChange(e.target.value)}
              className="!h-8 !w-[240px] [&_.ant-input]:!text-[13px] [&_.ant-input]:!font-normal"
            />
          </div>
        </ConfigProvider>
        <Select
          allowClear
          placeholder={t('scope.category')}
          style={{ width: 113 }}
          className="!h-8 !text-[13px] [&_.ant-select-suffix]:text-black"
          classNames={{ popup: { root: '[&_.ant-select-item]:!text-[13px]' } }}
          suffixIcon={<ChevronDownIcon width={16} height={16} />}
          value={category}
          onChange={(v) => onCategoryChange(v)}
          options={categories.map((c) => ({ label: categoryNames[c] || c, value: c }))}
        />
      </Space>
    </Flex>
  )
}
